import React, { useEffect, useState } from 'react';
import HoverIcon from 'components/HoverIcon';
import { Role, RoleName, RoleDescription } from './styles';
import RoleInput from './RoleInput';
import { display } from 'components/ErrorView/ErrorDialog';
import messages from '../Messages';
import { DraggableProvided } from 'react-beautiful-dnd';
import Icon from 'components/Icon/Icon';
import { MyBadge } from 'components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/styles';
import { convertDigitToProperFormat } from 'utils/number';
import Collapsible from 'components/Collapsible/Collapsible';
import RolesList from './RolesList';
import { black, lightGreen, red } from 'utils/style/colors';
import IconTypes from 'components/Icon/IconTypes';
import {
  ICompanyRole,
  IProjectMemberView,
  TProjects,
} from 'store/companies/companiesTypes';
import { IUsers } from 'store/store';
import { ITags } from 'store/providers/providerTypes';
import {
  CompanyAdvanceAdminRole,
  SupportRole,
} from '../../../../store/companies/companiesUtils';
import i18n from '../../../../i18n';
// import { SupportRole } from 'store/entity/ICompanyRole';

interface IRolesListItemProps {
  roleItem: ICompanyRole;
  allRoles: ICompanyRole[];
  updateRole: (role: ICompanyRole) => Promise<any>;
  addPrefixRoles: (role: ICompanyRole) => Promise<any>;
  deleteRole: (roleId: number, companyId: number) => () => void;
  provided?: DraggableProvided;
  projects: TProjects;
  allProjectTags: string[];
  providerIds: number[];
  users: IUsers;
  tags: ITags;
  isAdvancedEditor: boolean;
  isAdvancedAdmin: boolean;
}

const RolesListItem: React.FC<IRolesListItemProps> = ({
  roleItem,
  allRoles,
  deleteRole,
  updateRole,
  addPrefixRoles,
  provided,
  allProjectTags,
  users,
  tags,
  providerIds,
  projects,
  isAdvancedEditor,
  isAdvancedAdmin,
}) => {
  const [editing, setEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  // const [addingPrefixedRoles, setAddingPrefixedRoles] = useState<boolean>(
  //   false
  // );
  useEffect(() => {
    setEditing(false);
    setLoading(false);
  }, [roleItem]);

  const processUpdateRole = (role: ICompanyRole) => {
    setLoading(true);
    return updateRole(role)
      .then(() => {
        setLoading(false);
        setEditing(false);
      })
      .catch((err) => {
        display(err);
        setLoading(false);
      });
  };
  // const doAddPrefixRoles = () => {
  //   const appliedRoles = allRoles.reduce((prev, item) => {
  //     let ret = prev;
  //     if (
  //       item.id !== roleItem.id &&
  //       item.name
  //         .replace(/[\s|‌]+/, '')
  //         .startsWith(roleItem.name.replace(/[\s|‌]+/, ''))
  //     ) {
  //       if (ret.length !== 0) {
  //         ret = ret + ', ';
  //       }
  //       ret = ret + item.name;
  //       return ret;
  //     } else return prev;
  //   }, '');
  //   if (appliedRoles.length === 0) {
  //     alert(messages.noPrefixedRoleFound);
  //     return;
  //   }
  //   if (
  //     window.confirm(
  //       messages.confirmAddPrefixRoles(roleItem.name, appliedRoles)
  //     )
  //   ) {
  //     setAddingPrefixedRoles(true);
  //
  //     addPrefixRoles(roleItem).then(
  //       () => {
  //         setAddingPrefixedRoles(false);
  //       },
  //       (err) => {
  //         display(err);
  //         setAddingPrefixedRoles(false);
  //       }
  //     );
  //   }
  // };
  const iAmSurrounding = allRoles.filter((it) =>
    it.surroundingMeRoles?.includes(roleItem.id ?? 0)
  );
  let icon: IconTypes;
  switch (roleItem.roleType) {
    case 'Post':
      icon = 'chevrons-up';
      break;
    case 'InProject':
      icon = 'clipboard';
      break;
    case 'District':
      icon = 'home';
      break;
    case 'Compound':
      icon = 'link';
      break;
    default:
      icon = 'info';
  }

  let warning = '';
  if (roleItem.roleType === 'District' && !roleItem.relatedTagId)
    warning = i18n.t('missingTag', { ns: 'companyManagement' });
  else if (roleItem.isUnique && roleItem.users.length > 1)
    warning = i18n.t('exactly1MemberShouldBeAssigned', {
      ns: 'companyManagement',
    });
  else if (roleItem.isUnique && roleItem.users.length < 1)
    warning = i18n.t('noOneAssigned', { ns: 'companyManagement' });
  else if (roleItem.users.length === 0) {
    const projectIncludesMe = Object.values(projects || {})?.find((item) => {
      const iProjectMemberViews = Object.values(item.projectRoleMembers);
      const foundMembership = iProjectMemberViews.find(
        (pm: IProjectMemberView) => {
          return pm.roleId === roleItem.id;
        }
      );
      return !!foundMembership;
    });
    if (projectIncludesMe)
      warning = messages.usedInProjectsButEmpty(projectIncludesMe.name);
  }

  return (
    <li
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      style={{
        cursor: !provided ? 'default' : undefined,
        ...provided?.draggableProps.style,
        backgroundColor: editing ? lightGreen : undefined,
      }}
      ref={provided?.innerRef}
    >
      {!editing ? (
        <div style={{ display: 'contents' }}>
          <div className="hover-area">
            <Role>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <RoleName>
                  <div>
                    <Icon type={icon} style={{ marginInlineEnd: '10px' }} />
                    {roleItem.isUnique && (
                      <Icon
                        title={
                          i18n.t('roleIsUnique', {
                            ns: 'companyManagement',
                          }) as string
                        }
                        type={roleItem.isUnique ? 'user' : 'users'}
                        color={roleItem.users.length !== 1 ? red : black}
                        style={{ marginInlineEnd: '10px' }}
                      />
                    )}

                    {roleItem.displayName}
                  </div>
                  <span style={{ color: red }}>{warning}</span>
                </RoleName>
              </div>
              <RoleDescription>{roleItem.description}</RoleDescription>
            </Role>
            {roleItem.id && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  minHeight: '28px',
                }}
              >
                {roleItem.isProjectRole && (
                  <div>
                    {roleItem.projectTags?.map((it: string) => (
                      <MyBadge key={it} hollow={false} color="gray">
                        {it}
                      </MyBadge>
                    ))}
                    {(!roleItem.projectTags ||
                      !roleItem.projectTags.length) && (
                      <MyBadge key={'allProjects'} hollow={false} color="gray">
                        {
                          i18n.t('allProjects', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      </MyBadge>
                    )}
                  </div>
                )}
                {!roleItem.isProjectRole && (
                  <details
                    style={{ display: 'inline', cursor: 'pointer' }}
                    open={roleItem.users.length < 2}
                  >
                    <summary style={{ display: 'inline' }}>
                      <a>
                        {(i18n.t('membersCount', {
                          ns: 'companyManagement',
                        }) as string) +
                          ' ' +
                          convertDigitToProperFormat(roleItem.users.length)}
                      </a>
                    </summary>
                    {!!roleItem.users.length && (
                      <span>
                        {' (' +
                          roleItem.users.map(
                            (user, index) =>
                              (users.map[user.userId]?.name || ' ') +
                              (index !== roleItem.users.length - 1 ? ', ' : '')
                          ) +
                          ') '}
                      </span>
                    )}
                  </details>
                )}
                <div></div>
                {roleItem.roleType !== 'Compound' &&
                  (isAdvancedEditor ||
                    (roleItem.roleType === 'Post' &&
                      !roleItem.compoundCreationWithRoleId &&
                      roleItem.name !== SupportRole &&
                      roleItem.name !== CompanyAdvanceAdminRole)) && (
                    <div style={{ float: 'left' }} className="visible-on-hover">
                      <HoverIcon
                        type="trash"
                        color="red"
                        onClick={deleteRole(roleItem.id, roleItem.companyId!)}
                      />
                      <HoverIcon
                        type="edit"
                        color="cobalt"
                        onClick={() => setEditing(true)}
                      />
                    </div>
                  )}
              </div>
            )}
          </div>
          {(iAmSurrounding.length > 0 || roleItem.roleType === 'District') && (
            <Collapsible
              header={i18n.t('subs', { ns: 'companyManagement' }) as string}
              nested
            >
              <div>
                {iAmSurrounding.length > 0 && (
                  <RolesList
                    roles={iAmSurrounding}
                    allRoles={allRoles}
                    deleteRole={deleteRole}
                    updateRole={updateRole}
                    allProjectTags={allProjectTags}
                    users={users}
                    projects={projects}
                    enableReOrder={false}
                    addPrefixRoles={addPrefixRoles}
                    tags={tags}
                    providerIds={providerIds}
                    isAdvancedEditor={isAdvancedEditor}
                    isAdvancedAdmin={isAdvancedAdmin}
                  />
                )}
                {roleItem.roleType === 'District' &&
                  (isAdvancedEditor || isAdvancedAdmin) && (
                    <Collapsible
                      header={messages.addRole(roleItem.name)}
                      iconName={'plus'}
                      nested
                    >
                      <RoleInput
                        addOrUpdateRole={updateRole}
                        loading={loading}
                        companyId={Number(roleItem.companyId)}
                        hideAdvancedConfig={!isAdvancedEditor}
                        cancelEdit={() => {
                          /*do nothing*/
                        }}
                        maxRoleOrder={iAmSurrounding.reduce((current, item) => {
                          if ((item.order ?? 0) > current)
                            return item.order || 0;
                          return current;
                        }, -10000)}
                        allProjectTags={[]}
                        allRoles={allRoles}
                        roleType={'District'}
                        tags={tags}
                        parent={roleItem}
                        providerIds={providerIds}
                      />
                    </Collapsible>
                  )}
              </div>
            </Collapsible>
          )}
        </div>
      ) : (
        <RoleInput
          role={roleItem!}
          addOrUpdateRole={processUpdateRole}
          loading={loading}
          companyId={roleItem.companyId!}
          cancelEdit={() => {
            setEditing(false);
          }}
          allProjectTags={allProjectTags}
          allRoles={allRoles}
          tags={tags}
          providerIds={providerIds}
          hideAdvancedConfig={!isAdvancedEditor}
        />
      )}
    </li>
  );
};

export default RolesListItem;
